
@if(!commonUtil.isMobileDevice()){
    @if(histry.clientWidth + histry.scrollLeft < histry.scrollWidth - 2){
        <span class="scroll-right" (click)="scrollRight(histry)"></span>
    }
    @else{
        <span class="scroll-right inactive"></span>
    }
    @if(histry.scrollLeft>0){
        <span class="scroll-left" (click)="scrollLeft(histry)"></span>
    }
    @else {
        <span class="scroll-left inactive"></span>
    }
}
<div #histry class="scroll-panel">
    @for (visit of visits; track visit.user_id;let i=$index) {
    @if($first&&!commonUtil.isMobileDevice()){
        <div class="base-container leading-element">
            <span style="font: 500 18px/24px var(--manrope);color: var(--text-secondary); text-align: center">
                Visit history details
            </span>
            <span class="icon" style="min-width: fit-content"></span>
            <span style="font: 400 16px/21px var(--manrope);color: var(--text-tertiary); text-align: center">
                This page will be updated in parallel with the field worker's visit to
            </span>
            <span style="font: 400 16px/21px var(--manrope);color: var(--text-tertiary);text-align: center;">
                Scroll right to view all visits made by various field workers
            </span>
        </div>
    }
    <div class="base-container" [class.highlighted]="currentUserId===visit.user_id.toString()"><!---->
        <li class="base-container element">
            <span class="title">Visited on</span>
            <span class="body">{{visit.visitDate|date:'dd MMM yyyy'}}</span>
        </li>
        <li class="base-container element">
            <span class="title">Visited by</span>
            <span class="body">{{visit.visitedBy}}</span>
        </li>
        <li class="base-container element">
            <span class="title">Category</span>
            @for (feedback of visit.feedbackCategory; track feedback.feedbackCategoryId) {
                <span class="body">{{feedback.feedbackCategoryMsg}}</span>
            }
        </li>
        <li class="base-container element">
            <span class="title">Comments</span>
            @for (comment of visitComments[i]; track comment) {
                <span class="body">{{comment}}</span>
            }
        </li>
        <li class="base-container element">
            <span class="title">Accompanied by</span>
            @if (!visit.accomp_wrk_dtl){
                <span class="body">--</span>
            }
            @for (wrkr of visit.accomp_wrk_dtl; track $index) {
                <span class="body">
                    {{(wrkr.accompWrkName)?wrkr.accompWrkName+' ':''}}
                    {{(wrkr.accompWrkType)?'('+wrkr.accompWrkType+') ':''}}
                </span>
                <span class="sub-text">
                    {{(wrkr.accompWrkDistrict)?'('+wrkr.accompWrkDistrict:''}}
                    {{(wrkr.accompWrkState)?', '+wrkr.accompWrkState+')':''}}
                </span>
            }
        </li>
        <!-- <li class="base-base-container element">
            <span class="title">Update Status</span>
            <span class="body updated">● Updated</span>
        </li> -->
        <li class="base-container element">
            <span class="title">Contact number</span>
            <span class="body" [class.clickable]="contactClickable&&currentUserId!==visit.user_id.toString()"
            (click)="(currentUserId!==visit.user_id.toString())?fetchMemberContact():{}">
                {{visit.contact}}
            </span>
        </li>
        <li class="base-container element">
            <span class="title">Family code</span>
            <span class="body">{{(visit.familyCode)?visit.familyCode:'--'}}</span>
        </li>
        <!-- <li class="base-container element">
            <span class="title">Attachments</span>
            <span class="body">--</span>
        </li> -->
        @if(!commonUtil.isMobileDevice()){
            <li class="base-container element">
                <span class="title">Location</span>
                <span class="body">
                    <a (click)="openMap(i)">
                        https://www.google.com/maps/search
                    </a>
                </span>
            </li>
        }
        @else {
            <button class="dp-secondary-btn" style="padding: 12px 10px"
            (click)="openMap(i)">
                <span class="material-icons">
                    near_me
                </span>
            </button>
        }
        <!-- <li class="base-container element">
            <span class="title">Expected address</span>
            @if(visit.address){
                <span class="body">{{visit.address}}</span>
            }
            @else {
                <span class="body">--</span>
            }
        </li>
        <li class="base-container element">
            <span class="title">Expected landmark</span>
            @if(visit.landmark){
                <span class="body">{{visit.landmark}}</span>
            }
            @else{
                <span class="body">--</span>
            }
        </li> -->
    </div>
    }
    @empty{
        @if(false){<!--!errorPresent||emptyMessage===''-->
            @for (item of [1,1,1,1,1,1,1,1,1,1,1,1]; track $index) {
                <div class="base-container">
                    <div class="base-container element placeholder-glow">
                        <span class="placeholder w-25 rounded-1 bar"></span>
                        <span class="placeholder w-25 rounded-1 bar"></span>
                    </div>
                    <div class="base-container element placeholder-glow">
                        <span class="placeholder w-25 rounded-1 bar"></span>
                        <span class="placeholder w-25 rounded-1 bar"></span>
                    </div>
                    <div class="base-container element placeholder-glow">
                        <span class="placeholder w-25 rounded-1 bar"></span>
                        <span class="placeholder w-25 rounded-1 bar"></span>
                    </div>
                    <div class="base-container element placeholder-glow">
                        <span class="placeholder w-25 rounded-1 bar"></span>
                        <span class="placeholder w-25 rounded-1 bar"></span>
                    </div>
                    <div class="base-container element placeholder-glow">
                        <span class="placeholder w-100 rounded-1 bar"></span>
                        <span class="placeholder w-50 rounded-1 bar"></span>
                        <span class="placeholder w-100 rounded-1 bar"></span>
                        <span class="placeholder w-50 rounded-1 bar"></span>
                    </div>
                    <div class="base-container element placeholder-glow">
                        <span class="placeholder w-25 rounded-1 bar"></span>
                        <span class="placeholder w-25 rounded-1 bar"></span>
                    </div>
                </div>
            }
        }
        @else if (errorPresent) {
            <span class="empty"><em>{{errorMessage}}</em></span>
        }
        @else {
            <div class="empty block">
                <span class="title"><em>{{emptyMessage}}</em></span>
                <span class="icon"></span>
                <span class="body">This page will be updated in parallel to field-workers visit to</span>
            </div>
        }
    }
</div>